/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Transaction server Services 
 * These services provide APIs to interact with transaction
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The purchase order individual term and condition. <br>Used for one order and acceptable purchase order numbers are not predefined. You can specify that customers must use a unique purchase order number for each order placed on behalf of a business account. If you do not require a unique purchase order number for each order, customers may reuse purchase order numbers.
 * @export
 * @interface POTCIndividualAllOf
 */
export interface POTCIndividualAllOf {
    /**
     * The full entity class name of the term and condition.
     * @type {string}
     * @memberof POTCIndividualAllOf
     */
    _class?: POTCIndividualAllOfClassEnum;
    /**
     * The purchase order number must be unique.
     * @type {string}
     * @memberof POTCIndividualAllOf
     */
    checkUniqueness?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum POTCIndividualAllOfClassEnum {
    ComIbmCommerceTradingEntitiesPotcIndividual = 'com.ibm.commerce.trading.entities.POTCIndividual'
}



